import React from 'react';
import { WebComponentRenderer } from '../../../angular-in-react/WebComponentRenderer';
import { Target } from '../../activate-target/models/target';
import { Activation } from '../models/activation';

export interface ChangeMappingDialogConfig {
  visible: boolean;
  activation?: Activation;
  target?: Target;
  query?: string;
  mapping?: any;
}

export interface ChangeMappingDialogProps {
  config: ChangeMappingDialogConfig;
  onClose: ({ mappingUpdated }: { mappingUpdated: boolean }) => any;
}

export interface ChangeMappingDialogAngularInReactProps {
  config: ChangeMappingDialogConfig;
  onClose: ({ mappingUpdated }: { mappingUpdated: boolean }) => any;
}

export function ChangeMappingDialog(props: ChangeMappingDialogProps) {
  return (
    <WebComponentRenderer
      elementSelector='change-mapping-dialog-web-component'
      {...(props as ChangeMappingDialogAngularInReactProps)}
    >
      {/* @ts-ignore */}
      <change-mapping-dialog-web-component></change-mapping-dialog-web-component>
    </WebComponentRenderer>
  );
}
